import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate } from "react-router";



export function Private({children}){

    const {signed, loadingAuth} = useContext(AuthContext);

    if(loadingAuth){
        return <div></div>
    }

    if(!signed){
        return <Navigate to="/login" />
    }

    return children;
}